export const translations = {
  es: {
    nav: {
      home: "Inicio",
      about: "Sobre Jenny",
      scorecard: "Evaluación",
      resources: "Recursos",
      events: "Eventos",
      social: "Social",
      contact: "Contacto",
      admin: "Admin"
    },
    hero: {
      title: "Construye Riqueza y Legado",
      subtitle: "Empoderando a mujeres emprendedoras para dominar sus finanzas y crear un impacto global.",
      cta: "Evalúa Tu Potencial de Riqueza"
    },
    about: {
      title: "Sobre Jenny Rodriguez-Minchala",
      role: "Directora Ejecutiva de Marketing de Global Financial Impact",
      bio: "Fundadora del movimiento Mujeres y Riquezas y Ejecutiva de Prosperity Leaders. Jenny se dedica a cerrar la brecha de riqueza para las mujeres latinas a través de la educación financiera y el emprendimiento.",
      featured: "Destacada en:",
      cta: "Conoce Más"
    },
    scorecard: {
      title: "Scorecard de Empoderamiento Financiero",
      subtitle: "Descubre tu nivel actual de preparación financiera en menos de 2 minutos.",
      start: "Comenzar Evaluación",
      categories: {
        personal: "Fundamentos Personales",
        business: "Salud del Negocio",
        investment: "Inversiones",
        legacy: "Planificación de Legado",
        tax: "Estrategia Fiscal"
      },
      questions: [
        "¿Tienes un presupuesto personal documentado que sigues mensualmente?",
        "¿Tienes un fondo de emergencia de 3-6 meses de gastos?",
        "¿Pagas tus tarjetas de crédito en su totalidad cada mes?",
        "¿Tu negocio genera ganancias netas consistentes mes a mes?",
        "¿Te pagas un salario de mercado a ti misma desde tu negocio?",
        "¿Conoces tus márgenes de beneficio exactos por producto/servicio?",
        "¿Inviertes al menos el 20% de tus ingresos netos?",
        "¿Tienes una cartera de inversiones diversificada?",
        "¿Entiendes la diferencia entre activos que se aprecian y pasivos?",
        "¿Tienes un testamento o fideicomiso actualizado?",
        "¿Tienes un seguro de vida que cubra las necesidades de tu familia?",
        "¿Tienes un plan de sucesión para tu negocio?",
        "¿Revisas tu estrategia fiscal trimestralmente con un profesional?",
        "¿Aprovechas todas las deducciones fiscales disponibles para tu negocio?",
        "¿Tu estructura legal (LLC, Corp) está optimizada para impuestos?"
      ],
      resultTitle: "Tu Puntuación de Riqueza",
      emailPrompt: "Ingresa tu correo para ver tus resultados detallados y recibir tu plan de acción.",
      levels: {
        foundation: "Nivel Fundación",
        growth: "Nivel Crecimiento",
        leader: "Nivel Líder"
      },
      cta: "Agenda Tu Consulta Gratuita"
    },
    calculator: {
      title: "Calculadora de Riqueza Empresarial",
      income: "Ingresos Mensuales del Negocio ($)",
      years: "Años en el Negocio",
      invest: "Porcentaje a Invertir (%)",
      calculate: "Calcular Proyección",
      result: "Proyección de Riqueza",
      chartTitle: "Crecimiento Proyectado",
      disclaimer: "Basado en un retorno anual promedio estimado del 8%.",
      cta: "Descubre Más Estrategias"
    },
    resources: {
      title: "Recursos Gratuitos",
      download: "Descargar",
      items: [
        { title: "10 Estrategias para Construir Riqueza", desc: "Guía PDF esencial." },
        { title: "Guía de Inversión para Emprendedoras", desc: "Ebook completo." },
        { title: "Lista de Reducción de Impuestos", desc: "Checklist práctica." },
        { title: "Planificación de Legado", desc: "Workbook interactivo." }
      ]
    },
    events: {
      title: "Próximos Eventos",
      register: "Registrarse Ahora",
      details: "Ver Todos los Eventos"
    },
    newsletter: {
      title: "Únete a la Comunidad",
      placeholder: "Tu mejor correo electrónico",
      button: "Suscribirse",
      privacy: "Acepto recibir correos de Mujeres y Riquezas. Puedes darte de baja en cualquier momento.",
      success: "¡Gracias por suscribirte!"
    },
    ctaMain: {
      title: "¿Lista para Transformar tus Finanzas?",
      schedule: "Agenda Tu Consulta",
      events: "Ver Eventos"
    },
    footer: {
      rights: "Todos los derechos reservados."
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About Jenny",
      scorecard: "Scorecard",
      resources: "Resources",
      events: "Events",
      social: "Social",
      contact: "Contact",
      admin: "Admin"
    },
    hero: {
      title: "Build Wealth and Legacy",
      subtitle: "Empowering women entrepreneurs to master their finances and create global impact.",
      cta: "Evaluate Your Wealth Potential"
    },
    about: {
      title: "About Jenny Rodriguez-Minchala",
      role: "Executive Marketing Director of Global Financial Impact",
      bio: "Founder of the Mujeres y Riquezas movement and Executive at Prosperity Leaders. Jenny is dedicated to closing the wealth gap for Latinas through financial education and entrepreneurship.",
      featured: "Featured in:",
      cta: "Learn More"
    },
    scorecard: {
      title: "Financial Empowerment Scorecard",
      subtitle: "Discover your current level of financial readiness in less than 2 minutes.",
      start: "Start Assessment",
      categories: {
        personal: "Personal Foundations",
        business: "Business Health",
        investment: "Investments",
        legacy: "Legacy Planning",
        tax: "Tax Strategy"
      },
      questions: [
        "Do you have a documented personal budget you follow monthly?",
        "Do you have an emergency fund covering 3-6 months of expenses?",
        "Do you pay off your credit cards in full every month?",
        "Does your business generate consistent net profits monthly?",
        "Do you pay yourself a market-rate salary from your business?",
        "Do you know your exact profit margins per product/service?",
        "Do you invest at least 20% of your net income?",
        "Do you have a diversified investment portfolio?",
        "Do you understand the difference between appreciating assets and liabilities?",
        "Do you have an up-to-date will or trust?",
        "Do you have life insurance that covers your family's needs?",
        "Do you have a succession plan for your business?",
        "Do you review your tax strategy quarterly with a professional?",
        "Do you take advantage of all available tax deductions for your business?",
        "Is your legal structure (LLC, Corp) optimized for taxes?"
      ],
      resultTitle: "Your Wealth Score",
      emailPrompt: "Enter your email to view detailed results and receive your action plan.",
      levels: {
        foundation: "Foundation Level",
        growth: "Growth Level",
        leader: "Leader Level"
      },
      cta: "Schedule Free Consultation"
    },
    calculator: {
      title: "Business Wealth Calculator",
      income: "Monthly Business Income ($)",
      years: "Years in Business",
      invest: "Percentage to Invest (%)",
      calculate: "Calculate Projection",
      result: "Wealth Projection",
      chartTitle: "Projected Growth",
      disclaimer: "Based on an estimated average annual return of 8%.",
      cta: "Discover More Strategies"
    },
    resources: {
      title: "Free Resources",
      download: "Download",
      items: [
        { title: "10 Strategies to Build Wealth", desc: "Essential PDF guide." },
        { title: "Investment Guide for Entrepreneurs", desc: "Complete Ebook." },
        { title: "Tax Reduction Checklist", desc: "Practical checklist." },
        { title: "Legacy Planning", desc: "Interactive workbook." }
      ]
    },
    events: {
      title: "Upcoming Events",
      register: "Register Now",
      details: "See All Events"
    },
    newsletter: {
      title: "Join the Community",
      placeholder: "Your best email",
      button: "Subscribe",
      privacy: "I agree to receive emails from Mujeres y Riquezas. You can unsubscribe at any time.",
      success: "Thanks for subscribing!"
    },
    ctaMain: {
      title: "Ready to Transform Your Finances?",
      schedule: "Schedule Consultation",
      events: "See Events"
    },
    footer: {
      rights: "All rights reserved."
    }
  }
};